import { render } from "./single.vue?vue&type=template&id=ec52b93c&scoped=true"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"

import "./single.vue?vue&type=style&index=0&id=ec52b93c&scoped=true&lang=less"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec52b93c"]])

export default __exports__